import { StyledIconUser } from './IconUser.styled';

const IconUser = () => {
  return <StyledIconUser />;
};

export default IconUser;
